<template>
  <sn-combobox
    v-model="selectedOrganizations"
    placeholder="Select org IDs this user can access"
    multiple
    attach
    :disabled="disabled"
    :items="organizations"
    item-text="name"
  >
    <template
      v-slot:selection="{item, parent}"
    >
      <v-chip
        :key="item.key"
        :close="!disabled"
        close-icon="sn-icon-exit"
        color="#F3F5F7"
        @click:close="parent.selectItem(item)"
      >
        <span class="sn-text-primary">{{ displayName(item) }}</span>
      </v-chip>
    </template>
    <template
      v-slot:item="data"
    >
      <v-icon
        v-if="selectedGuids.includes(data.item.guid)"
        style="margin-right: 12px"
        color="#22A969"
      >
        sn-icon-check
      </v-icon>
      <span class="item-font">{{ displayName(data.item) }}</span>
    </template>
  </sn-combobox>
</template>

<script>

export default {
  name: 'SrOrganizationCombobox',
  props: {
    organizations: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    }
  },
  data () {
    return {
      selectedOrganizations: []
    }
  },
  computed: {
    selectedGuids () {
      return this.selectedOrganizations.map(o => o.guid)
    }
  },
  watch: {
    value (newVal) {
      this.selectedOrganizations = newVal
    },
    selectedOrganizations (newVal) {
      this.$emit('input', this.selectedOrganizations)
    }
  },
  created () {
    this.selectedOrganizations = this.value || []
  },
  methods: {
    displayName (org) {
      if (org.active) {
        return org.name
      } else {
        return `${org.name} - inactive`
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

.item-font {
  font-family: "Open Sans", sans-serif !important;
}

</style>
